//**************************************************************************************************
//*************************************** TaskDataService ****************************
//**************************************************************************************************

'use strict';

class TaskDataService{

  constructor($http,$q,$rootScope,MessagingService)
  {
      this.cache = {};
      this.$http = $http;
      this.$q=$q;
      this.$rootScope =$rootScope;
      this.MessagingService =MessagingService;
        
  }
    static $inject = ['$http','$q','$rootScope','MessagingService'];
 
    
	  GetTaskParameters (taskId) {
       
          var http_method="";
          var url='../api/task-parameters-byresourceid/';
                 
         
          http_method="GET";
          if (taskId!=undefined) {
            url=url+taskId+'/';
          }
            var deferred = this.$q.defer();   
          
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                      
                       deferred.resolve(data);
                       
                    } else {
                        deferred.reject({msg:'Data download failed ! '+data.status+' '+data.data,status:data.status});
                   
                    }  
               
                    
                },function (error) {

                    // if error, bind success message to message
                   deferred.reject({msg:'Data download failed ! '+error.status+' '+error,status:error.status});


                });
                return deferred.promise;
        };  
  
  
  //**********************************************************
	//           SAVE TASK PARAMETRS
  //**********************************************************      
  SaveTaskParameters  (taskId,taskParameters) {
    
          var http_method="POST";
          var taskIdLocal="";
          
          if (taskId!=undefined) {
            //code
            taskIdLocal=taskId+"/";
            http_method="PUT";
          }
          
          
          var url='../api/task-parameters/'+taskIdLocal;
             var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                data: taskParameters
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200 || data.status === 201) {
                    
                          
                      deferred.resolve(data.data);
                
                
                    } else {
                      if (data.data.msg==undefined) data.data.msg='Error saving task parameters';
                      
                      deferred.reject(data.data);

                    }
                },function (data) {

                    // if error, bind success message to message
                     if (data.data.msg==undefined) data.data.msg='Error saving task parameters';
                     
                    deferred.reject(data.data);

                });
                   return deferred.promise;
        };
 
  
  //**********************************************************
	//           GET OUTCOME DEFINITION
  //**********************************************************      
  GetOutcomeDefinition  (outcomeDefinitionId,lang) {
    
          var http_method="GET";
          
          var url='../api/task-outcome-definition/'+outcomeDefinitionId+'/'+lang+'/';
             var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    
                          
                      deferred.resolve({data:data.data,status:data.status});
                
                
                    } else {
                      deferred.reject({msg:'Get outcome definition failed ! --> '+data.data,status:data.status});

                    }
                },function (data) {

                    // if error, bind success message to message
                  deferred.reject({msg:'Get outcome definition failed ! '+data.status+' '+data.data,status:data.status});

                });
                   return deferred.promise;
        };
   
  //**********************************************************
	//           SAVE OUTCOME DEFINITION
  //**********************************************************      
  SaveOutcomeDefinition  (outcome_head) {
    
          var http_method="POST";
          var id=0;
          if (outcome_head.id!=null && outcome_head.id!=undefined) id = outcome_head.id;
          var url='../api/task-outcome-definition/'+id+'/'+outcome_head.Lang+'/';
             var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },
                data: outcome_head

            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    
                          
                      deferred.resolve({data:data.data,status:status});
                
                
                    } else {
                      deferred.reject({msg:'Get outcome definition failed ! --> '+data.data,status:data.status});

                    }
                },function (data) {

                    // if error, bind success message to message
                  deferred.reject({msg:'Get outcome definition failed ! '+data.status+' '+data.data,status:data.status});

                });
                   return deferred.promise;
        };
   
                
 //**********************************************************
	//           GET TASK OUTCOMES DEFINITIONS
  //**********************************************************      
  GetTaskOutcomesDef  (lang) {
    
          var http_method="GET";
          
          var url='../api/get-task-outcomes-def/'+lang;
             var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200 || data.status === 201) {
                    
                          
                      deferred.resolve({data:data.data,msg:'Task outcomes saved successfully ! '+data.status+' ',status:data.status});
                
                
                    } else {
                      deferred.reject({msg:'Get outcomes failed ! --> '+data.data,status:data.status});

                    }
                },function (data) {

                    // if error, bind success message to message
                  deferred.reject({msg:'Save failed ! '+data.status+' '+data.data,status:data.status});

                });
                   return deferred.promise;
        };
   
 //**********************************************************
	//           GET TASK OUTCOMES
  //**********************************************************      
  GetTaskOutcomes  (taskId,codeId,lang) {
    
          var http_method="GET";
                 
          var url='../api/get-task-outcomes-details/';
          var taskIdLocal="";
           if (taskId!=undefined) {
            //code
            taskIdLocal=taskId+"/"+codeId+"/"+lang+"/";
          }
          
          var deferred = this.$q.defer(); 
          
          this.$http({
                method: http_method,
                url: url+taskIdLocal,
                headers: { 'Content-Type': 'application/json' },

                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                      
                        deferred.resolve({data: data.data,status:data.status});
                      
                                         
                    } else {
                        deferred.reject({msg: "Get task outcomes ! "+data.data,status:data.status});
                      
                        //console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: "Get task outcomes failed ! "+data.data,status:data.status});


                });
                   return deferred.promise;
        };    
 //**********************************************************
	//           SAVE TASK OUTCOMES
  //**********************************************************      
  SaveTaskOutcomes  (taskId,hasOutcomes,outcomes,lang) {
    
          var http_method="POST";
          var taskIdLocal="";
          
          if (taskId!=undefined) {
            //code
            taskIdLocal=taskId+"/";
           // http_method="POST";
          }
          
          
          var url='../api/save-task-outcomes/'+taskIdLocal+lang+'/';
             var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                data: {'outcomes':outcomes,'hasOutcomes':hasOutcomes}
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200 || data.status === 201) {
                    
                          
                      deferred.resolve({data:data.data,msg:'Task outcomes saved successfully ! '+data.data+' ',status:data.status});
                
                
                    } else {
                      deferred.reject({msg:'Save failed ! '+data.data,status:data.status});

                    }
                },function (data) {

                    // if error, bind success message to message
                  deferred.reject({msg:'Save failed ! '+data.data,status:data.status});

                });
                   return deferred.promise;
        };

   //**********************************************************
	//           SAVE TASK STATUSES
  //**********************************************************      
  SaveTaskStatuses  (taskId,codesActions,codeName) {
    
          var http_method="POST";
          var parameters="";
          
          if (taskId!=undefined) {
            //code
            parameters=taskId+"/"+codeName+'/';
           // http_method="POST";
          }
          
          
          var url='../api/save-task-codes-actions/'+parameters;
             var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                data: codesActions
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200 || data.status === 201) {
                    
                          
                      deferred.resolve({data:data,msg:'Task statuses saved successfully ! '+data.data+' ',status:data.status});
                
                
                    } else {
                      deferred.reject({msg:'Save failed ! '+data.data,status:data.status });

                    }
                },function (data) {

                    // if error, bind success message to message
                  deferred.reject({msg:'Save failed ! '+data.data,status:data.status});

                });
                   return deferred.promise;
        };
               
  //**********************************************************
	//           SAVE TASK ASSIGNMENTS
  //**********************************************************      
  SaveTaskAssignments  (taskAssignments,taskId,selfAssigned,publicTask,uniqueName,assignType,taskType) {
    
          var http_method="POST";
                 
          var url='../api/save-task-assignments/'+taskId+'/'+assignType+'/';
          
          var deferred = this.$q.defer(); 
          
          this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                data: {'ta':taskAssignments,'SelfAssigned':selfAssigned,'PublicTask':publicTask,'UniqueName':uniqueName,'taskType':taskType}
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200 || data.status === 201) {
                     // $scope.dashboard.widgets = data;
                   
                   
                            deferred.resolve({msg: data.data.msg,status:data.status});
                
                
                      
                //      $scope.activity.activityMessage =   ProcessingService.hideActivity().activityMessage;  
                 
                      
                    } else {
                         deferred.reject({msg: data.data.msg,status:data.status});

                    }
                },function (data) {

                    // if error, bind success message to message
                    deferred.reject({msg: data.data.msg,status:data.status});


                });
                   return deferred.promise;
        };
   //**********************************************************
	//           GET TASK EXECUTE DATA
  //**********************************************************      
  GetTaskExecuteData  (taskInstanceId,lang) {
    
          var http_method="GET";
                 
          var url='../api/get-task-execute-data/';
          var taskIdLocal="";
           if (taskInstanceId!=undefined) {
            //code
            taskIdLocal=taskInstanceId+"/"+lang+"/";
          }
          console.log(new Date());
          var deferred = this.$q.defer(); 
          
          this.$http({
                method: http_method,
                url: url+taskIdLocal,
                headers: { 'Content-Type': 'application/json' },

                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                        console.log(new Date());
                        deferred.resolve({data: data.data,status:data.status});
                      
                                         
                    } else {
                        deferred.reject({msg: "Get failed ! "+data.data,status:data.status});
                      
                        //console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: "Get failed ! "+data.data,status:data.status});


                });
                   return deferred.promise;
        };
      
  //**********************************************************
	//           GET TASK ASSIGNMENTS
  //**********************************************************      
  GetTaskAssignments  (taskId) {
    
          var http_method="GET";
                 
          var url='../api/task-assignment-byresourceid/';
          var taskIdLocal="";
           if (taskId!=undefined) {
            //code
            taskIdLocal=taskId+"/";
          }
          
          var deferred = this.$q.defer(); 
          
          this.$http({
                method: http_method,
                url: url+taskIdLocal,
                headers: { 'Content-Type': 'application/json' },

                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                      
                        deferred.resolve({data: data.data,status:data.status});
                      
                                         
                    } else {
                        deferred.reject({msg: "Get failed ! "+data.status+" "+data.data,status:data.status});
                      
                        //console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: "Get failed ! "+data.status+" "+data.data,status:data.status});


                });
                   return deferred.promise;
        };

 //**********************************************************
	//           GET TASK OUTCOMES
  //**********************************************************      
  GetTaskCodesActionsById  (taskId,lang,codeId) {
    
          var http_method="GET";
                 
          var url='../api/get-task-codes-actions-byid/';
          var taskIdLocal="";
           if (taskId!=undefined) {
            //code
            taskIdLocal=taskId+"/"+lang+"/"+codeId+"/";
          }
          
          var deferred = this.$q.defer(); 
          
          this.$http({
                method: http_method,
                url: url+taskIdLocal,
                headers: { 'Content-Type': 'application/json' },

                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                      
                        deferred.resolve({data: data.data,status:data.status});
                      
                                         
                    } else {
                        deferred.reject({msg: "Get task outcomes ! "+data.status+" "+data.data,status:data.status});
                      
                        //console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: "Get task outcomes failed ! "+data.status+" "+data.data,status:data.status});


                });
                   return deferred.promise;
        };
//**********************************************************
	//           GET CODES ACTION BY NAME
  //**********************************************************      
  GetTaskCodesActionsByName  (taskId,lang,codeName) {
    
          var http_method="GET";
                 
          var url='../api/get-task-codes-actions-byname/';
          var taskIdLocal="";
           if (taskId!=undefined) {
            //code
            taskIdLocal=taskId+"/"+lang+"/"+codeName+"/";
          }
          
          var deferred = this.$q.defer(); 
          
          this.$http({
                method: http_method,
                url: url+taskIdLocal,
                headers: { 'Content-Type': 'application/json' },

                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                      
                        deferred.resolve({data: data.data,status:data.status});
                      
                                         
                    } else {
                        deferred.reject({msg: "Get task outcomes ! "+data.status+" "+data.data,status:data.status});
                      
                        //console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: "Get task outcomes failed ! "+data.status+" "+data.data,status:data.status});


                });
                   return deferred.promise;
        };
        
  //**********************************************************
	//           GET INITIATED TASKS
  //**********************************************************      
  getInitiatedTasks  (type,filter) {
    
          var http_method="GET";
          
          var lang=this.$rootScope.globals.currentUser.lang;
          
          var url='../api/get-initiated-tasks/'+type+'/'+filter+'/'+lang+'/';
         
          //console.log(new Date());        
          var deferred = this.$q.defer(); 
          
          this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                        //console.log(new Date());
                        deferred.resolve({data: data.data,status:data.status});
                      
                                         
                    } else {
                        deferred.reject({msg: "Get failed ! "+data.status+" "+data.data,status:data.status});
                      
                        //console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: "Get failed ! "+data.status+" "+data.data,status:data.status});

                });
                   return deferred.promise;
        };
  
  //**********************************************************
	//           GET INITIATED TASK PAGINATED
  //**********************************************************      
  getInitiatedTasksPaginated  (type,filter,url_next,url_prev,new_page,page_size) {
    
          var http_method="GET";
          
          var lang=this.$rootScope.globals.currentUser.lang;
          
          var url='../api/get-initiated-tasks/'+type+'/'+filter+'/'+lang+'/';
          if (new_page!="" && new_page!=undefined)
          {
            url = url+'?page='+new_page
            if (page_size!="" && page_size!=undefined)
            {
            url = url+'&page_size='+page_size
            
            }
          }
       /*   if (url_next!="" && url_next!=undefined)
          {
            url = url_next;
            
          }
          if (url_prev!="" && url_prev!=undefined)
          {
            url = url_prev;
            
          }*/
          
          //console.log(new Date());        
          var deferred = this.$q.defer(); 
          
          this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                        //console.log(new Date());
                        deferred.resolve({data: data.data,status:data.status});
                      
                                         
                    } else {
                        deferred.reject({msg: "Get failed ! "+data.status+" "+data.data,status:data.status});
                      
                        //console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: "Get failed ! "+data.status+" "+data.data,status:data.status});

                });
                   return deferred.promise;
        };
         //**********************************************************
	//           GET INITIATED TASK PAGINATED FILTERED
  //**********************************************************      
  getInitiatedTasksPaginatedFiltered  (type,filter,url_next,url_prev,new_page,page_size,f_filter) {
    
          var http_method="POST";
          
          var lang=this.$rootScope.globals.currentUser.lang;
          
          var url='../api/get-initiated-tasks-filtered/'+type+'/'+filter+'/'+lang+'/';
          if (new_page!="" && new_page!=undefined)
          {
            url = url+'?page='+new_page
            if (page_size!="" && page_size!=undefined)
            {
            url = url+'&page_size='+page_size
            
            }
          }
       /*   if (url_next!="" && url_next!=undefined)
          {
            url = url_next;
            
          }
          if (url_prev!="" && url_prev!=undefined)
          {
            url = url_prev;
            
          }*/
          
          //console.log(new Date());        
          var deferred = this.$q.defer(); 
          
          this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                 data: f_filter,
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                        //console.log(new Date());
                        deferred.resolve({data: data.data,status:data.status});
                      
                                         
                    } else {
                        deferred.reject({msg: data.data,status:data.status});
                      
                        //console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: data.data,status:data.status});

                });
                   return deferred.promise;
        };
  /**********************************************************
	***************** PRE-INITITATE TASK  ******************
	***********************************************************/     
  preInitiateTask  (taskId,prevTask,lang,prevTaskPackage) {
    
          var http_method="POST";
                 
          var url='../api/pre-initiate-task/'+taskId+'/'+prevTask+'/'+lang+'/';
          
          var deferred = this.$q.defer(); 
          
          this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                data: {'ptp':prevTaskPackage},
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    
                            deferred.resolve({data: data.data,status:data.status});
                
                      
                    } else {
                      
                    deferred.reject({msg: "Get task form failed ! "+data.status+" "+data.data,status:data.status});
                  
                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: "Get task form failed ! "+data.status+" "+data.data,status:data.status});


                });
                   return deferred.promise;
        };
 /**********************************************************
	***************** INITITATE TASK  ******************
	***********************************************************/     
  InitiateTask  (taskId,transactionId,taskData,potentialOwners,datasetId,datasetRecordId,lang) {
    
          var http_method="POST";
                 
          var url='../api/initiate-task/'+taskId+'/'+transactionId+'/'+datasetId+'/'+datasetRecordId+'/'; 
          var deferred = this.$q.defer(); 
          
          this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                data: {'taskData':taskData,'potentialOwners':potentialOwners} 
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    
                     
                     deferred.resolve({data: data.data,status:data.status});
                     
                      
                    } else {
                        var msg=''
                        if (data.data.msg== undefined) msg = data.data;
                        else msg = data.data.msg;
                        deferred.reject({msg: msg,status:data.status});

                    }
                },function (data) {

                    // if error, bind error message to message
                    var msg=''
                    if (data.data.msg== undefined) msg = data.data;
                    else msg = data.data.msg;
                    deferred.reject({msg: msg,status:data.status});


                });
                   return deferred.promise;
        };
  /**********************************************************
	***************** PRE-EXECUTE TASK  ******************
	***********************************************************/     
  preExecuteTask  (taskInitiateId,taskExecuteId,lang) {
    
          var http_method="GET";
                 
          var url='../api/pre-execute-task/'+taskInitiateId+'/'+taskExecuteId+'/'+lang+'/';
          
          var deferred = this.$q.defer(); 
          
          this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                //data: taskAssignments
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    
                            deferred.resolve({data: data.data,status:data.status});
                
                      
                    } else {
                        deferred.reject({msg: "Pre-execute task failed ! "+data.status+" "+data.data,status:data.status});
                
                

                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: "Pre-execute task failed ! "+data.status+" "+data.data,status:data.status});


                });
                   return deferred.promise;
        };
        /**********************************************************
	***************** EXECUTE TASK ACTION  ******************
	***********************************************************/     
  ExecuteTaskAction  (taskInitiateId,taskExecuteId,action,lang,forGroup) {
    
          var http_method="POST";
          
          if (forGroup==null || forGroup==undefined || forGroup=="") forGroup=0; 
                 
          var url='../api/task-status-action/'+taskInitiateId+'/'+taskExecuteId+'/'+action+'/'+lang+'/'+forGroup+'/';
          +lang+'/'
          var deferred = this.$q.defer(); 
          
          this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                //data: taskAssignments
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200 || data.status === 201) {
                    
                            deferred.resolve({data: data.data,status:data.status});
                
                      
                    } else {
                        deferred.reject({msg: data.data.msg+" "+data.status,status:data.status});
                
                

                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: data.data.msg+" "+data.status,status:data.status});


                });
                   return deferred.promise;
        };
  /**********************************************************
	***************** EXECUTE TASK  ******************
	***********************************************************/     
  executeTask  (taskId,taskData,outcomeId,lang) {
    
          var http_method="POST";
          
          if (taskId!=undefined)
          {
          var url='../api/execute-task/'+taskId+'/'+lang+'/';
          
          var deferred = this.$q.defer(); 
          
          this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                data: {'taskData':taskData,'outcome':outcomeId} 
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    
                            deferred.resolve({data: data.data,status:data.status});
                
                      
                    } else {
                       deferred.reject({msg: "Execute task failed ! "+data.status+" "+data.data,status:data.status});

                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: "Execute task failed ! "+data.status+" "+data.data,status:data.status});


                });
                   return deferred.promise;
          }
        };
  /**********************************************************
	***************** PROCESS TASK  ******************
	***********************************************************/     
  ProcessTask  (itemId,outcomeId,lang,idType,previousTaskId) {
    
          var http_method="POST";
          
          if (idType==undefined || idType==null || idType=="") idType='m';
          if (previousTaskId==undefined || previousTaskId==null || previousTaskId=="") previousTaskId=0;
                 
          var url='../api/process-task/'+itemId+'/'+outcomeId+'/'+idType+'/'+previousTaskId+'/'+lang+'/';
          
          
          var deferred = this.$q.defer(); 
          
          this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

               // data: {'ptp':prevTaskPackage},
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    
                            deferred.resolve({data: data.data,status:data.status});
                
                      
                    } else {
                      
                    deferred.reject({msg: data.data.msg,status:data.status});
                  
                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: data.data.msg,status:data.status});


                });
                   return deferred.promise;
        };
  /**********************************************************
	***************** START TASK  ******************
	***********************************************************/     
  StartTask  (taskId,outcomeId,previousTaskId) {
    
          var http_method="GET";
     
          var url='../api/start-task/'+taskId+'/'+outcomeId+'/'+previousTaskId+'/';
          
          
          var deferred = this.$q.defer(); 
          /* var gotoServer = false;
        if (this.cache['StartTask'] !==undefined)
         {
         if(this.cache.StartTask[taskId+'_'+outcomeId+'_'+previousTaskId] !==undefined)
         {
            deferred.resolve({data:  this.cache.StartTask[taskId+'_'+outcomeId+'_'+previousTaskId],status:200});
         }
         else
         {
           this.cache['StartTask'][taskId+'_'+outcomeId+'_'+previousTaskId] = {};
           gotoServer=true; 
         }
         } else
         {
            this.cache['StartTask'] = {};
            this.cache['StartTask'][taskId+'_'+outcomeId+'_'+previousTaskId] = {};
            gotoServer=true;
         }  
         if (gotoServer)
         { */
          this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

               // data: {'ptp':prevTaskPackage},
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                           
                           if (data!=null)
                           {
                             // instance.cache['StartTask'][taskId+'_'+outcomeId+'_'+previousTaskId] = data;
                              deferred.resolve({data: data.data,status:data.status});
                           }
                           else deferred.reject({msg: data.data.msg,status:data.status});
                      
                    } else {
                      
                    deferred.reject({msg: data.data.msg,status:data.status});
                  
                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: data.data.msg,status:data.status});


                });
       //  }
                   return deferred.promise;
        };
   /**********************************************************
	***************** SAVE TASK FORM DATA ******************
	***********************************************************/     
  saveTaskFormData  (taskId,taskData) {
    
          var http_method="POST";
                 
          var url='../api/save-task-form-data/'+taskId+'/';
          
          var deferred = this.$q.defer(); 
          
          this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                data: taskData,
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    
                            deferred.resolve({data: data.data,status:data.status});
                
                      
                    } else {
                       deferred.reject({msg: data.data,status:data.status});

                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: data.data,status:data.status});


                });
                   return deferred.promise;
        };
    //**********************************************************
	//           SAVE TASK FORM BUTTONS 
  //**********************************************************      
  SaveTaskBtns  (taskBtns,taskId,lang) {

          var  http_method="POST";
     
         
          
          var url='../api/save-task-btns/'+taskId+'/'+lang+'/';
             var deferred = this.$q.defer(); 
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                data: taskBtns
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    
                          
                      deferred.resolve({msg:data});
                
                
                    } else {
                      deferred.reject({msg:data});

                    }
                },function (data) {

                    // if error, bind success message to message
                  deferred.reject({msg:data});

                });
                   return deferred.promise;
        };
           
   /**********************************************************
	***************** SAVE TASK TO RESOURCE ******************
	***********************************************************/     
  saveTaskToResource  (taskExecuteId,datasetDefId,datasetRecordId,presentationId) {
    
          var http_method="POST";
                 
          var url='../api/save-task-to-resource/'+taskExecuteId+'/'+datasetDefId+'/'+datasetRecordId+'/'+presentationId+'/';
          
          var deferred = this.$q.defer(); 
          
          this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                //data: taskData,
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    
                            deferred.resolve({data: data.data,status:data.status});
                
                      
                    } else {
                       deferred.reject({msg: data.data,status:data.status});

                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: data.data,status:data.status});


                });
                   return deferred.promise;
        };
  //**********************************************************
	//           GET WIDGET DEPENDENCIES
  //**********************************************************      
  getWidgetDependencies  (taskDefId,presentationId,formType) {
    
         var http_method="GET";
                 
         var url='../api/get-widget-dependencies/'+taskDefId+'/'+presentationId+'/'+formType+'/';
        
         var deferred = this.$q.defer(); 
         var gotoServer = false;
         if (this.cache['getWidgetDependencies'] !==undefined)
         {
         if(this.cache.getWidgetDependencies[taskDefId+'_'+presentationId+'_'+formType] !==undefined)
         {
            deferred.resolve({data:  this.cache.getWidgetDependencies[taskDefId+'_'+presentationId+'_'+formType],status:200});
         }
         else
         {
           this.cache['getWidgetDependencies'][taskDefId+'_'+presentationId+'_'+formType] = {};
           gotoServer=true; 
         }
      } else
      {
         this.cache['getWidgetDependencies'] = {};
         this.cache['getWidgetDependencies'][taskDefId+'_'+presentationId+'_'+formType] = {};
         gotoServer=true;
      }  
      if (gotoServer)
      {
        var instance = this;
          this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                        instance.cache.getWidgetDependencies[taskDefId+'_'+presentationId+'_'+formType]=data.data;
                        deferred.resolve({data: data.data,status:data.status});
                      
                                         
                    } else {
                        deferred.reject({msg: data.data,status:data.status});
                      
                        
                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: data.data,status:data.status});


                });
      }
                   return deferred.promise;
        };

//**********************************************************
	//           Execute task dataset list
	//**********************************************************      
   ktTaskDatasetList (resourceId,presentationId,taskId,formType,lang) {
    
          var http_method="GET";
          
          var url='../api/kt-task-dataset-list/'+ resourceId +'/'+presentationId+'/'+taskId+'/'+formType+'/'+lang+'/';
          var deferred = this.$q.defer();
          
          
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                   
                       deferred.resolve({data: data.data,status:data.status});
                    
                      
                    } else {
                        deferred.reject({msg: 'kt-task-dataset-list error ! '+data.status+' '+data.data,status:data.status}); 

                      
                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: 'kt-task-dataset-list error ! '+data.status+' '+data.data,status:data.status}); 

                });
      
                return deferred.promise;
        };
  
      
      //**********************************************************
	//           Execute task get resource data PANDAS
	//**********************************************************      
   ktGetResourceDataPandas (resourceId,presentationId,taskId,formType,lang) {
    
          var http_method="GET";
          
          var url='../api/get-resource-data-pandas/'+ resourceId +'/'+presentationId+'/'+taskId+'/'+formType+'/'+lang+'/';
          var deferred = this.$q.defer();
          //debugger #pandas
          
          this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },   
          }).then (
                function (data) {
                    data.status === 200 ?  deferred.resolve({data: data.data,status:data.status}) :  deferred.reject({msg: 'get-resource-data-pandas error ! '+ data.status+' '+data.data,status:data.status});  
                },
                function (data) {  // if error, bind success message to message
                   deferred.reject({msg: 'get-resource-data-pandas error ! '+ data.status + ' '+data.data,status:data.status}); 
                });
      
                return deferred.promise;
    };
        
        
   /**********************************************************
	***************** SET FORM FIELD ******************
	***********************************************************/  
  setField (form,name,value)
        {
     				if (form!=undefined){
            	for(var i=0;i<form.length;i++) {
                
                    if (name in form[i])
                    {
                      form[i][name] = value;
                     }
                      if ('layout' in form[i])
                      {
                           
                         this.setField(form[i].layout,name,value);
                      }
              }
            }
        }
   /**********************************************************
	***************** SAVE GRID STATE ******************
	***********************************************************/     
  saveGridState  (taskDefId,presentationId,state,lang) {
    
          var http_method="POST";
                 
          var url='../api/save-grid-state/'+taskDefId+'/'+presentationId+'/'+lang+'/';
          
          var deferred = this.$q.defer(); 
          
          this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                data: state,
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    
                            deferred.resolve({data: data.data,status:data.status});
                
                      
                    } else {
                       deferred.reject({msg: data.data,status:data.status});

                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: data.data,status:data.status});


                });
                   return deferred.promise;
        };
	getCodes (code_id,language){
             var codeIndex=-1;
             if (code_id != undefined) {
              var deferred = this.$q.defer();                   
              var pos = listOfCodesById.map(function(e) { return e.unique_id; }).indexOf(code_id+language);
              if (pos<0){
				  //if  not found - download
			
      
			this.$http({
                method: 'GET',
                url: '../api/get-codes-detail-byidlang/'+ code_id+'/'+language+'/',
                headers: { 'Content-Type': 'application/json' },

               // data: $scope.resource
             
            })
                .then(function (data) {

                    if (data.status === 200) {
              
                      var retrivedList = {unique_id: code_id+language, id: code_id,lang: language, codeList: data.data};
              
          			  listOfCodesById.push(retrivedList);
                      codeIndex=listOfCodesById.length-1;
                      deferred.resolve(listOfCodesById[codeIndex].codeList, data.status);
                      
                    } else {
                        deferred.reject(data.data);
                    }
                },function (data) {
                    
                   
                    deferred.reject(data.data);
                });
				
              } else {
                codeIndex=pos;
                deferred.resolve(listOfCodesById[codeIndex].codeList, 200);
              }
            };
	
          return deferred.promise;
		  };
		 
}

export default TaskDataService;

export class PublicTaskDataService {
 
 constructor($http,$q,$rootScope,MessagingService)
  {
      this.cache = {};
      this.$http = $http;
      this.$q=$q;
      this.$rootScope =$rootScope;
      this.MessagingService =MessagingService;
        
  }
    static $inject = ['$http','$q','$rootScope','MessagingService']
 
    
    /**********************************************************
	***************** START TASK  ******************
	***********************************************************/     
   StartTask  (organisationId,taskName,taskId,outcomeId,previousTaskId) {
    
      var http_method="GET";
     
      var url='../api/start-public-task/'+organisationId+'/'+taskName+'/'+taskId+'/'+outcomeId+'/'+previousTaskId+'/';
          
          
      var deferred = this.$q.defer(); 
          
      this.$http({
         method: http_method,
         url: url,
         headers: { 'Content-Type': 'application/json' },
      })
      .then(function (data) {
                    // console.log(data);

         if (data.status === 200) {
                    
            deferred.resolve({data: data.data,status:data.status});
                
                      
         }
         else {
                      
            deferred.reject({msg: data.data.msg,status:data.status});
                  
         }
      },function (data) {

      // if error, bind success message to message
         deferred.reject({msg: data.data.msg,status:data.status});


      });
      return deferred.promise;
   };
    
   GetTaskParameters  (taskId) {
       
          var http_method="";
          var url='../api/task-parameters-byresourceid/';
                 
         
          http_method="GET";
          if (taskId!=undefined) {
            url=url+taskId+'/';
          }
            var deferred = this.$q.defer();   
          
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                      
                    //  if (data.length>0) {
                      
                      
                        deferred.resolve({data: data.data,status:data.status});
                      //}
                     /* else
                      {
                        deferred.reject({msg:'Data download failed ! '+data.status+' '+data,data.status:data.status});  
                        
                      }*/
                                         
                      
                    } else {
                        deferred.reject({msg:'Data download failed ! '+data.status+' '+data.data,status:data.status});
                   
                    }  
               
                    
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg:'Data download failed ! '+data.status+' '+data.data,status:data.status});


                });
                return deferred.promise;
        };  
  
 //**********************************************************
	//           GET TASK OUTCOMES
  //**********************************************************      
  GetTaskOutcomes  (taskId,codeId,lang) {
    
          var http_method="GET";
                 
          var url='../api/get-task-outcomes-details/';
          var taskIdLocal="";
           if (taskId!=undefined) {
            //code
            taskIdLocal=taskId+"/"+codeId+"/"+lang+"/";
          }
          
          var deferred = this.$q.defer(); 
          
          this.$http({
                method: http_method,
                url: url+taskIdLocal,
                headers: { 'Content-Type': 'application/json' },

                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                      
                        deferred.resolve({data: data.data,status:data.status});
                      
                                         
                    } else {
                        deferred.reject({msg: "Get task outcomes ! "+data.status+" "+data.data,status:data.status});
                      
                        //console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: "Get task outcomes failed ! "+data.status+" "+data.data,status:data.status});


                });
                   return deferred.promise;
        };    

               
   //**********************************************************
	//           GET TASK EXECUTE DATA
  //**********************************************************      
  GetTaskExecuteData  (taskInstanceId,lang) {
    
          var http_method="GET";
                 
          var url='../api/get-task-execute-data/';
          var taskIdLocal="";
           if (taskInstanceId!=undefined) {
            //code
            taskIdLocal=taskInstanceId+"/"+lang+"/";
          }
          
          var deferred = this.$q.defer(); 
          
          this.$http({
                method: http_method,
                url: url+taskIdLocal,
                headers: { 'Content-Type': 'application/json' },

                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                        
                        deferred.resolve({data: data.data,status:data.status});
                      
                                         
                    } else {
                        deferred.reject({msg: "Get failed ! "+data.status+" "+data.data,status:data.status});
                      
                        //console.log(data);
                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: "Get failed ! "+data.status+" "+data.data,status:data.status});


                });
                   return deferred.promise;
        };
      
  
  /**********************************************************
	***************** PRE-INITITATE TASK  ******************
	***********************************************************/     
  preInitiateTask  (taskId,prevTask,lang,prevTaskPackage) {
    
          var http_method="POST";
                 
          var url='../api/pre-initiate-task/'+taskId+'/'+prevTask+'/'+lang+'/';
          
          var deferred = this.$q.defer(); 
          
          this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                data: {'ptp':prevTaskPackage},
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    
                            deferred.resolve({data: data.data,status:data.status});
                
                      
                    } else {
                      
                    deferred.reject({msg: "Get task form failed ! "+data.status+" "+data.data,status:data.status});
                  
                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: "Get task form failed ! "+data.status+" "+data.data,status:data.status});


                });
                   return deferred.promise;
        };
 /**********************************************************
	***************** INITITATE TASK  ******************
	***********************************************************/     
  InitiateTask  (taskId,transactionId,taskData,potentialOwners,datasetId,datasetRecordId,lang) {
    
          var http_method="POST";
                 
          var url='../api/initiate-task/'+taskId+'/'+transactionId+'/'+datasetId+'/'+datasetRecordId+'/'; 
          var deferred = this.$q.defer(); 
          
          this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                data: {'taskData':taskData,'potentialOwners':potentialOwners} 
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    
                     
                     deferred.resolve({data: data.data,status:data.status});
                     
                      
                    } else {
                        var msg=''
                        if (data.msg== undefined) msg = data.data;
                        else msg = data.data.msg;
                        deferred.reject({msg: msg,status:data.status});

                    }
                },function (data) {

                    // if error, bind error message to message
                    var msg=''
                    if (data.data.msg== undefined) msg = data.data;
                    else msg = data.data.msg;
                    deferred.reject({msg: msg,status:data.status});


                });
                   return deferred.promise;
        };
  /**********************************************************
	***************** PRE-EXECUTE TASK  ******************
	***********************************************************/     
  preExecuteTask  (taskInitiateId,taskExecuteId,lang) {
    
          var http_method="GET";
                 
          var url='../api/pre-execute-task/'+taskInitiateId+'/'+taskExecuteId+'/'+lang+'/';
          
          var deferred = this.$q.defer(); 
          
          this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                //data: taskAssignments
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    
                            deferred.resolve({data: data.data,status:data.status});
                
                      
                    } else {
                        deferred.reject({msg: "Pre-execute task failed ! "+data.status+" "+data.data,status:data.status});
                
                

                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: "Pre-execute task failed ! "+data.status+" "+data.data,status:data.status});


                });
                   return deferred.promise;
        };
  /**********************************************************
	***************** EXECUTE TASK ACTION  ******************
	***********************************************************/     
  ExecuteTaskAction  (taskInitiateId,taskExecuteId,action,lang,forGroup) {
    
          var http_method="POST";
          
          if (forGroup==null || forGroup==undefined || forGroup=="") forGroup=0; 
                 
          var url='../api/task-status-action/'+taskInitiateId+'/'+taskExecuteId+'/'+action+'/'+lang+'/'+forGroup+'/';
          +lang+'/'
          var deferred = this.$q.defer(); 
          
          this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                //data: taskAssignments
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200 || data.status === 201) {
                    
                            deferred.resolve({data: data.data,status:data.status});
                
                      
                    } else {
                        deferred.reject({msg: data.data.msg+" "+data.status,status:data.status});
                
                

                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: data.data.msg+" "+data.status,status:data.status});


                });
                   return deferred.promise;
        };
  /**********************************************************
	***************** EXECUTE TASK  ******************
	***********************************************************/     
  executeTask  (taskId,taskData,outcomeId,lang) {
    
          var http_method="POST";
          
          if (taskId!=undefined)
          {
          var url='../api/execute-task/'+taskId+'/'+lang+'/';
          
          var deferred = this.$q.defer(); 
          
          this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

                data: {'taskData':taskData,'outcome':outcomeId} 
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    
                            deferred.resolve({data: data.data,status:data.status});
                
                      
                    } else {
                       deferred.reject({msg: "Execute task failed ! "+data.status+" "+data.data,status:data.status});

                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: "Execute task failed ! "+data.status+" "+data.data,status:data.status});


                });
                   return deferred.promise;
          }
        };
  /**********************************************************
	***************** PROCESS TASK  ******************
	***********************************************************/     
  ProcessTask  (itemId,outcomeId,lang,idType,previousTaskId) {
    
          var http_method="POST";
          
          if (idType==undefined || idType==null || idType=="") idType='m';
          if (previousTaskId==undefined || previousTaskId==null || previousTaskId=="") previousTaskId=0;
                 
          var url='../api/process-task/'+itemId+'/'+outcomeId+'/'+idType+'/'+previousTaskId+'/'+lang+'/';
          
          
          var deferred = this.$q.defer(); 
          
          this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },

               // data: {'ptp':prevTaskPackage},
                // data: { 'auction': $scope.auction }
            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    
                            deferred.resolve({data: data.data,status:data.status});
                
                      
                    } else {
                      
                    deferred.reject({msg: data.data.msg,status:data.status});
                  
                    }
                },function (data) {

                    // if error, bind success message to message
                   deferred.reject({msg: data.data.msg,status:data.status});


                });
                   return deferred.promise;
  }

}


export class TaskDefinitionService{
 
 constructor($rootScope,MessagingService)
  {
     
    
      this.$rootScope =$rootScope;
      this.MessagingService =MessagingService;
      this.selectedTask={};
      this.definitionScope=null;
      this.scope=null;
      this.task=null;
      this.showTaskInitiators = false;
      this.showTaskOwners = false;
      this.showTaskStatus = false;
      this.showTaskForm = "i";
      this.statusTransitionSelected = false;
      this.showActions=[false,false,false];   
  }
  
 static $inject = ['$rootScope','MessagingService']
 
    
    SetSelectedTask (task) {
          
        this.selectedTask = task;
        if (this.scope!=undefined) this.scope.$emit('TaskDefinitionLoaded',null);
    };
    
    SetScopeForSelectedTask  (scope) {
          
        this.scope = scope;
    };
    
     SetScopeForDefinition  (scope) {
          
        this.definitionScope = scope;
    };
    
     GetSelectedTask  (task) {
          
        return this.selectedTask;
    };
    
     showTaskOwnersFn (type){
     return this.showTaskOwners;
     };
     showTaskInitiatorsFn (type){
     return this.showTaskInitiators;
     };
     showTaskStatusFn (type){
     return this.showTaskStatus;
     };
 showHideTaskRoles(type){
    
        if (type==0){
          this.showTaskInitiators = true;
          this.showTaskOwners = false;
          this.showTaskStatus = false;
        }
        if (type==1)
        {
          this.showTaskInitiators = false;
          this.showTaskOwners = true;
          this.showTaskStatus = false;
          
        }
         if (type==2)
        {
          this.showTaskInitiators = false;
          this.showTaskStatus = false;
          //ovo vidjeti kako riješiti
          this.definitionScope.clearTaskAssignments();
          this.definitionScope.getTaskAssignments();
          
        }
           if (type==3)
        {
          this.showTaskOwners = false;
          this.showTaskStatus = false;
            
          this.definitionScope.clearTaskAssignments();
         
          this.definitionScope.processTaskAssignments(angular.copy(this.definitionScope.taskAssignmentsOriginal));
          this.task=angular.copy(this.definitionScope.taskOriginal);
          
        }
        this.showTaskForm='';
        this.statusTransitionSelected = false;
        this.showActions.fill(false);
        this.definitionScope.selectedDefinedActions = -1;
  };
  
    showHideTaskStatuses(index,state){
     
     this.showTaskStatus=false;
     this.definitionScope.selectedDefinedActions=index;
     this.showActions.fill(false);
     this.showActions[index]=state;
     this.showTaskStatus=state;
     this.showTaskInitiators = false;
     this.showTaskOwners = false;
     this.definitionScope.statusTransitionSelected = false;
     this.showTaskForm='';
  
    
     
     if (index==0)
     {
      this.getTaskStatusActions("created","created",index,state)
      
     }else{
        if (this.definitionScope.loadingActions.loading==undefined) this.definitionScope.loadingActions={loading:false};
        else this.definitionScope.loadingActions.loading=false;
     
     }
    
  };
  
  showHideTaskForm(formType){ // default form type=i
     
     this.showTaskForm=formType;
     this.showTaskInitiators = false;
     this.showTaskOwners = false;
     this.showTaskStatus=false;
     this.showActions.fill(false);
     this.definitionScope.selectedDefinedActions = -1;
  };
  showTaskFormFn (){
     return this.showTaskForm;
  };
  
  getSelectedActionFn (){
     return this.definitionScope.selectedDefinedActions;
  };

  getSelectedTransition (){
     return this.definitionScope.codesActions.selectedTransition;
  };
    
  getTransitionActionsCount(transition){

    if (this.definitionScope.codesActions.transitionList===undefined || this.definitionScope.codesActions.transitionList[transition]===undefined)  return '';
    else {
        return this.definitionScope.codesActions.transitionList[transition];
       }
    
    };

  getTaskStatusActions(taskStatusFrom,taskStatusTo,transition,state){
    
    //if ($scope.loadingActions.loading==undefined) $scope.loadingActions={loading:true};
    //else $scope.loadingActions.loading = true;
    this.definitionScope.taskStatusFrom = {name:null,id:null,value:null};
    this.definitionScope.taskStatusTo = {name:null,id:null,value:null};
    this.definitionScope.taskStatusFrom.name=taskStatusFrom;
    this.definitionScope.taskStatusTo.name=taskStatusTo;
    this.definitionScope.statusTransitionSelected = true;
    this.definitionScope.codesActions.selectedTransition = transition;
   
    //$scope.codesActions.codesActionsList.length=0;
       
        var pos = this.definitionScope.taskStatuses.map(function(e) { return e.value; }).indexOf(this.definitionScope.taskStatusFrom.name);
        if (pos>-1) {
          this.definitionScope.taskStatusFrom.id = this.definitionScope.taskStatuses[pos].id;
          this.definitionScope.taskStatusFrom.value = this.definitionScope.taskStatuses[pos].name;
        } 
  
        pos = this.definitionScope.taskStatuses.map(function(e) { return e.value; }).indexOf(this.definitionScope.taskStatusTo.name);
        if (pos>-1) {
          this.definitionScope.taskStatusTo.id = this.definitionScope.taskStatuses[pos].id;
          this.definitionScope.taskStatusTo.value = this.definitionScope.taskStatuses[pos].name;
        }
    
        this.showTaskInitiators = false;
        this.showTaskOwners = false;
        this.showTaskStatus=state;
    
        if (!state)  this.task=angular.copy(this.taskOriginal);
    
   };
   

 
 }

export class TaskProcService {
 
 constructor  ($http,$q,$rootScope,MessagingService,TaskDataService) {
    this.$http = $http;
    this.$q=$q;
    this.$rootScope =$rootScope;
    this.MessagingService =MessagingService;
    this.TaskDataService =TaskDataService;
      
    this.taskProcOriginal={};
    this.taskDataOriginal={};
 }
 
  static $inject = ['$http','$q','$rootScope','MessagingService','TaskDataService'];
    
    ProcessTask  (menuId,outcomeId,lang,initType,previousTaskId) {
          
         var deferred = this.$q.defer();
         if (initType==undefined || initType==null || initType=="") initType='m';
         if (previousTaskId==undefined || previousTaskId==null || previousTaskId=="") previousTaskId=0;
         
         if (this.taskProcOriginal[menuId+lang+initType+previousTaskId]!=undefined)
         {
            deferred.resolve(angular.copy(this.taskProcOriginal[menuId+lang+initType+previousTaskId])); 
         }
         else
         {
          var instance = this;
            TaskDataService.ProcessTask(menuId,outcomeId,lang,initType,previousTaskId).then(function(data) {
                                
                                 
                                  instance.taskProcOriginal[menuId+lang+initType+previousTaskId] = data;
                                  deferred.resolve(angular.copy(instance.taskProcOriginal[menuId+lang+initType+previousTaskId]));
                                  //deferred.resolve(data); 
                                     
     
                              },function(error){
                                
                              deferred.reject(error);
                                  
                            });
            
        }
      return deferred.promise;
    }
    
     StartTask  (taskId,outcomeId,previousTaskId) {
          
         var deferred = this.$q.defer();
         if (outcomeId==undefined || outcomeId==null || outcomeId=="") outcomeId=0;
         if (previousTaskId==undefined || previousTaskId==null || previousTaskId=="") previousTaskId=0;
         
         if (this.taskDataOriginal[taskId+outcomeId+previousTaskId]!=undefined)
         {
            deferred.resolve(angular.copy(this.taskDataOriginal[taskId+outcomeId+previousTaskId])); 
         }
         else
         {
          var instance = this;
            TaskDataService.StartTask(taskId,outcomeId,previousTaskId).then(function(data) {
                                
                                 
                                  instance.taskDataOriginal[taskId+outcomeId+previousTaskId] = data;
                                  deferred.resolve(angular.copy(instance.taskDataOriginal[taskId+outcomeId+previousTaskId]));
                                  //deferred.resolve(data); 
                                     
     
                              },function(error){
                                
                              deferred.reject(error);
                                  
                            });
            
        }
      return deferred.promise;
    }
    
    
    
    CompleteStartForm  (taskId,taskTransactionId) {
          
        var deferred = this.$q.defer();
        
            
        
      return deferred.promise;
    }
    CompleteTask  (taskExecuteId) {
          
      var deferred = this.$q.defer();
        
            
        
      return deferred.promise;
    }
    
 }